import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { 
  FaHome, 
  FaInfoCircle, 
  FaCar, 
  FaDollarSign, 
  FaEnvelope, 
  FaAddressCard, 
  FaStar // Added the icon for Reviews
} from "react-icons/fa";

function Navbar() {
  return (
    <header>
      <div className="container">
        <h1>STAR PRE-OWNED CARZ</h1>
        <nav>
          <ul>
            <li>
              <Link to="/">
                <FaHome className="icon" /> Home
              </Link>
            </li>
            <li>
              <Link to="/about">
                <FaInfoCircle className="icon" /> About Us
              </Link>
            </li>
            <li>
              <Link to="/cars">
                <FaCar className="icon" /> Cars
              </Link>
            </li>
            <li>
              <Link to="/sell-car">
                <FaDollarSign className="icon" /> Sell Your Car
              </Link>
            </li>
            <li>
              <Link to="/contact">
                <FaEnvelope className="icon" /> Contact Us
              </Link>
            </li>
            <li>
              <Link to="/profile">
                <FaAddressCard className="icon" /> Profile
              </Link>
            </li>
            <li>
              <Link to="/reviews">
                <FaStar className="icon" /> Reviews
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
